import { styled } from '@mui/material';

export const DrawerContentWrapper = styled('div')(() => ({
  paddingLeft: '5rem',
  flex: 1,
}));

export const DrawerHeader = styled('div')({
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  height: '2rem',
  borderBottom: '1px solid #BDC4CB',
  minWidth: 0, // Allow shrinking
});

export const DrawerHeaderContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flex: 1,
  paddingLeft: '5rem',
  minWidth: 0, // Allow shrinking
  overflowX: 'auto',
  // Hide scrollbar but keep functionality
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  // Responsive padding to prevent tabs from hiding behind sidebar
  '@media (max-width: 768px)': {
    paddingLeft: '3rem',
  },
  '@media (max-width: 480px)': {
    paddingLeft: '1rem',
  },
}));

export const DrawerSizeBar = styled('div')({
  height: '3px',
  cursor: 'row-resize',
  backgroundColor: '#ccc',
});
